import { useGetHttp } from "../../../http.hook";
import { IGetKycPendingListResponse } from "./get-pending-gst.admin.http";

export function useSearchGstAdminHttp() {
  return useGetHttp<IGetKycPendingListResponse>({
    path: "/admin/kyc/creator/gst/search",
  });
}